export default __webpack_public_path__ + "static/media/cross.18cc3eef.svg";